import axios from 'axios';
import './Registroest.css'
import './editarest.css'
import {useEffect, useState} from 'react';
import toast, { Toaster } from 'react-hot-toast';
import Cropper from 'react-easy-crop';
import  {getCroppedImg} from '../Componentes/cropImage';

import Logoicono from '../Componentes/logosvg2';
import Parqueo from '../Icons/1.png';
import Tarjeta from '../Icons/2.png';
import Cash from '../Icons/3.png';
import Deposito from '../Icons/4.png';

function EditarEst() {
   
const notify = () => toast.success('Edicion completada.', {position: 'bottom-right'});
const notifyerr = () => toast.error('No es posible.', {position: 'bottom-right'});
const [alldatos, setalldatos] = useState('');
const [canchasfut5, setCanchasfut5] = useState([]);
const [canchasfut7, setCanchasfut7] = useState([]);
const [canchasfut11, setCanchasfut11] = useState([]);
const [fotos, setFotos] = useState ([]);

const [errors, setErrors] = useState({
    NombreEstablecimiento: false,
    DireccionEstablecimiento: false,
    TelefonoEstablecimiento: false,
    WhatsappEstablecimiento: false,
    DescripcionEstablecimiento: false,
    LunApertura: false,
    LunCierre: false,
    MarApertura: false,
    MarCierre: false,
    MieApertura: false,
    MieCierre: false,
    JueApertura: false,
    JueCierre: false,
    VieApertura: false,
    VieCierre: false,
    SabApertura: false,
    SabCierre: false,
    DomApertura: false,
    DomCierre: false,
    NombreDueno: false,
    DPIDueno: false
});

    //CONSTANTES
//Checkboxes abren mas opciones
const [checkboxes, setCheckboxes] = useState({
    ctienefut5: false,
    ctienefut7: false,
    tieneparqueo: false,
    efectivo: false,
    transferencia: false,
    tarjeta: false,
    dialunes: false,
    diamartes: false,
    diamiercoles: false,
    diajueves: false,
    diaviernes: false,
    diasabado: false,
    diadomingo: false
    });

const handleCheckboxChange = (e) => {
    const { className, checked} = e.target;
    setCheckboxes((prev) => ({
        ...prev,
        [className]: checked
    }));
    switch (className) {
        case 'ctienefut5':
            setcanchascinco(0);
            setValoresCinco([]);
            break;
        case 'ctienefut7':
            setcanchassiete(0);
            setValoresSiete([]);
            setRelaciones([]);
            break;
        case 'dialunes':
            if (checkboxes.dialunes === false) {
                setEstable({...estable, ['LunApertura']: null, ['LunCierre']: null});
            } else {
                setEstable({...estable, ['LunApertura']: '', ['LunCierre']: ''});
            }
            break;
        case 'diamartes':
            if (checkboxes.diamartes === false) {
                setEstable({...estable, ['MarApertura']: null, ['MarCierre']: null});
            } else {
                setEstable({...estable, ['MarApertura']: '', ['MarCierre']: ''});
            }
            break;
        case 'diamiercoles':
            if (checkboxes.diamiercoles === false) {
                setEstable({...estable, ['MieApertura']: null, ['MieCierre']: null});
            } else {
                setEstable({...estable, ['MieApertura']: '', ['MieCierre']: ''});
            }
            break;
        case 'diajueves':
            if (checkboxes.diajueves === false) {
                setEstable({...estable, ['JueApertura']: null, ['JueCierre']: null});
            } else {
                setEstable({...estable, ['JueApertura']: '', ['JueCierre']: ''});
            }
            break;
        case 'diaviernes':
            if (checkboxes.diaviernes === false) {
                setEstable({...estable, ['VieApertura']: null, ['VieCierre']: null});
            } else {
                setEstable({...estable, ['VieApertura']: '', ['VieCierre']: ''});
            }
            break;
        case 'diasabado':
            if (checkboxes.diasabado === false) {
                setEstable({...estable, ['SabApertura']: null, ['SabCierre']: null});
            } else {
                setEstable({...estable, ['SabApertura']: '', ['SabCierre']: ''});
            }
            break;
        case 'diadomingo':
            if (checkboxes.diadomingo === false) {
                setEstable({...estable, ['DomApertura']: null, ['DomCierre']: null});
            } else {
                setEstable({...estable, ['DomApertura']: '', ['DomCierre']: ''});
            }
            break;
        case 'tieneparqueo':
            if (checkboxes.tieneparqueo === false) {
                setEstable({...estable, ['Tparqueo']: 'Si'});
            } else {
                setEstable({...estable, ['Tparqueo']: 'No'});
            }
            break;            
        case 'efectivo':
            if (checkboxes.efectivo === false) {
                setEstable({...estable, ['efectivo']: 'Si'});
            } else {
                setEstable({...estable, ['efectivo']: 'No'});
            }
            break;
        case 'transferencia':
            if (checkboxes.transferencia === false) {
                setEstable({...estable, ['transferencia']: 'Si'});
            } else {
                setEstable({...estable, ['transferencia']: 'No'});
            }
            break;
        case 'tarjeta':
            if (checkboxes.tarjeta === false) {
                setEstable({...estable, ['tarjeta']: 'Si'});
            } else {
                setEstable({...estable, ['tarjeta']: 'No'});
            } 
            break;
        default:
            break;
    }
    };

const [isediting, setisediting] = useState(false);

//INFO Establecimiento
const [estable, setEstable] = useState({
    NombreEstablecimiento: '',
    Departamento: '',
    Municipio: '',
    Zona: '', 
    DireccionEstablecimiento:'',
    TelefonoEstablecimiento:'',
    WhatsappEstablecimiento:'',
    DescripcionEstablecimiento:'',
    LunApertura: '',
    LunCierre: '',
    MarApertura: '',
    MarCierre: '',
    MieApertura: '',
    MieCierre: '',
    JueApertura: '',
    JueCierre: '',
    VieApertura: '',
    VieCierre: '',
    SabApertura: '',
    SabCierre: '',
    DomApertura: '',
    DomCierre: '',
    Tparqueo: 'No',
    efectivo: 'No', 
    tarjeta: 'No', 
    transferencia: 'No',
    NombreDueno:'',
    DPIDueno: '',
    DepositoFut5:'',
    PrecioFut5: '',
    PrecioFut7: '',
    DepositoFut7:''
});
const Registrar = (e) =>{
    e.persist();
    setEstable({...estable, [e.target.name]: e.target.value});
    if (e.target.value.trim() !== '') {
        setErrors({...errors, [e.target.name]: false});
    }
};

// Maneja los cambios en los inputs de Descripción y Precio
const handleDataCinco = (index, field, value) => {
    const newValues5 = [...canchasfut5];
    newValues5[index][field] = value; // Actualiza la descripción o el precio del input correspondiente
    setCanchasfut5(newValues5);
};
//Manejar imagenes

    const [crop, setCrop] = useState({});
    const [zoom, setZoom] = useState({});
    const [croppedAreaPixels, setCroppedAreaPixels] = useState({});

const updateCrop = (tipo, index, value) => {
setCrop((prev) => ({
...prev,
[tipo]: {
    ...(prev[tipo] || {}),
    [index]: value,
},
}));
};

const updateZoom = (tipo, index, value) => {
  setZoom((prev) => ({
    ...prev,
    [tipo]: {
      ...(prev[tipo] || {}),
      [index]: value,
    },
  }));
};

const updateCroppedAreaPixels = (tipo, index, value) => {
  setCroppedAreaPixels((prev) => ({
    ...prev,
    [tipo]: {
      ...(prev[tipo] || {}),
      [index]: value,
    },
  }));
};

const [imgcan, setImgcan] = useState({});
const handleImgCan = async (e, tipo, index) => {

    const file = e.target.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', () => {
        setImgcan((prev) => ({
            ...prev,
            [tipo]: {
                ...(prev[tipo] || {}),
                [index]: reader.result
            }
        }));
    });
    reader.readAsDataURL(file);
};

// Función que captura los datos y los imprime
async function handleSubmit2() {
    setTimer(true);
    // Validar campos vacíos
    let hasErrors = false;
    let newErrors = {...errors};
    
    Object.keys(estable).forEach((key) => {
        if (String(estable[key]).trim() === '') {
            newErrors[key] = true;
            hasErrors = true;
        }
    });
    setErrors(newErrors);
    if (hasErrors) {
        toast.error('Por favor, completa todos los campos.');
        setTimer(false);
        return;
    }
    const formData = new FormData();
    for (const tipo in imgcan) {
            if (tipo === 'perfil') {
            const imageSrc = imgcan[tipo][0];
            const cropData = croppedAreaPixels?.[tipo]?.[0];    
            const croppedImageBlob = await getCroppedImg(imageSrc, cropData, 1600, 1000, 1);
            const imageName = `${tipo}_${0}.webp`;
            formData.append('images', croppedImageBlob, imageName);

            // También puedes incluir metadata si lo deseas
            formData.append('metadatas', JSON.stringify({ tipo: tipo, index: 0 }));
            } else {
                for (const index in imgcan[tipo]) {
                    console.log('Corrio con tipo' , tipo, index);
                    
                const imageSrc = imgcan[tipo][index];
                const cropData = croppedAreaPixels?.[tipo]?.[index];

                if (!imageSrc || !cropData) continue; // Saltar si faltan datos

                const croppedImageBlob = await getCroppedImg(imageSrc, cropData, 400, 400, 0.8);

                // Crear un nombre único por si backend lo necesita
                const imageName = `${tipo}_${index}.webp`;
                formData.append('images', croppedImageBlob, imageName);

                // También puedes incluir metadata si lo deseas
                formData.append('metadatas', JSON.stringify({ tipo: tipo, index: index }));
                }
            };
        }
        formData.append('estable', JSON.stringify(estable));
        formData.append('canchasfut5', JSON.stringify(canchasfut5));
        formData.append('canchasfut7', JSON.stringify(canchasfut7));
        formData.append('canchasfut11', JSON.stringify(canchasfut11));
    try {
        await axios.post(`${process.env.REACT_APP_HTTPS}/api/establecimiento/update`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(response => {
                if (response){
                notify();
                setTimer(false);
                setisediting(false);
                }   
            })
            .catch((error) => {
                console.error('Error al guardar los datos:', error);
                notifyerr();
                setTimer(false);
                setisediting(false);
            });
    } catch (err) {
        console.error('Error al enviar imágenes recortadas:', err);
    }
};

const [timer, setTimer] = useState(true);

async function Cargar() {
    const datoscargados = await getEstablecimiento();
    if (datoscargados) {
      setalldatos(datoscargados.rows);
      setCanchasfut5(datoscargados.canchas.filter(todo => todo.tipo === 5));
      setCanchasfut7(datoscargados.canchas.filter(todo => todo.tipo === 7));
      setCanchasfut11(datoscargados.canchas.filter(todo => todo.tipo === 11));
      setFotos(datoscargados.fotos);
      setTimer(false);
      console.log(datoscargados.canchas.filter(todo => todo.tipo === 5));
      
      //cargo la data
    }
  }
  function getEstablecimiento(){
    return new Promise(resolve => {
        axios.get(`${process.env.REACT_APP_HTTPS}/api/establecimientos/editdatos`)
        .then((response) => {
          resolve (response.data);
        })
        .catch((error) => {
          console.error('Error al obtener las Reservas:', error);
        });
    })
};

useEffect(()=>{
    Cargar();
}, [])
useEffect(()=>{
    horarioschecked();
    setestableci();
}, [alldatos])

const horarioschecked = () => {
    if (alldatos.length > 0) {
        if (alldatos[0].LunesApertura === null) {
            setCheckboxes((prev) => ({...prev, dialunes: true}))
        };
        if (alldatos[0].MartesApertura === null) {
            setCheckboxes((prev) => ({...prev,diamartes: true}))
        };
        if (alldatos[0].MiercolesApertura === null) {
            setCheckboxes((prev) => ({...prev,diamiercoles: true}))
        };
        if (alldatos[0].JuevesApertura === null) {
            setCheckboxes((prev) => ({...prev,diajueves: true}))
        };
        if (alldatos[0].ViernesApertura === null) {
            setCheckboxes((prev) => ({...prev,diaviernes: true}))
        };
        if (alldatos[0].SabadoApertura === null) {
            setCheckboxes((prev) => ({...prev,diasabado: true}))
        };
        if (alldatos[0].DomingoApertura === null) {
            setCheckboxes((prev) => ({...prev,diadomingo: true}))
        };
        if (alldatos[0].Parqueo === 'Si') {
            setCheckboxes((prev) => ({...prev,tieneparqueo: true}))
        } else if (alldatos[0].Parqueo === 'No'){
            setCheckboxes((prev) => ({...prev,tieneparqueo: false}))
        };
        if (alldatos[0].Efectivo === 'Si') {
            setCheckboxes((prev) => ({...prev,efectivo: true}))
        } else if (alldatos[0].Efectivo === 'No'){
            setCheckboxes((prev) => ({...prev,efectivo: false}))
        };
        if (alldatos[0].Tarjeta === 'Si') {
            setCheckboxes((prev) => ({...prev,tarjeta: true}))
        } else if (alldatos[0].Tarjeta === 'No'){
            setCheckboxes((prev) => ({...prev,tarjeta: false}))
        };
        if (alldatos[0].Transferencia === 'Si') {
            setCheckboxes((prev) => ({...prev,transferencia: true}))
        } else if (alldatos[0].Transferencia === 'No'){
            setCheckboxes((prev) => ({...prev,transferencia: false}))
        };
    }
}

const setestableci = () => {
    if (alldatos.length > 0) {
        
        alldatos.forEach((datoest) =>{
            const datosarre = {
                NombreEstablecimiento: datoest.nombre,
                DireccionEstablecimiento: datoest.direccion,
                TelefonoEstablecimiento: datoest.telefono,
                WhatsappEstablecimiento:datoest.WhatsApp,
                DescripcionEstablecimiento:datoest.Descripcion,
                LunApertura: datoest.LunesApertura,
                LunCierre: datoest.LunesCierre,
                MarApertura: datoest.MartesApertura,
                MarCierre: datoest.MartesCierre,
                MieApertura: datoest.MiercolesApertura,
                MieCierre: datoest.MiercolesCierre,
                JueApertura: datoest.JuevesApertura,
                JueCierre: datoest.JuevesCierre,
                VieApertura: datoest.ViernesApertura,
                VieCierre: datoest.ViernesCierre,
                SabApertura: datoest.SabadoApertura,
                SabCierre: datoest.SabadoCierre,
                DomApertura: datoest.DomingoApertura,
                DomCierre: datoest.DomingoCierre,
                Tparqueo: datoest.Parqueo,
                efectivo: datoest.Efectivo,
                tarjeta: datoest.Tarjeta,
                transferencia: datoest.Transferencia,
                NombreDueno:datoest.Dueno,
                DPIDueno: datoest.DPI,
            }
        setEstable(datosarre);
        })
    }
}

const editarbtn = () => {
    setisediting(!isediting);
}
    return(
        <>
    <div className='Registroest'>
    {timer ? (<div className='cargando'>
              <div className='logocargando'><Logoicono/></div>
            </div>):(<>
                <p style={{fontWeight: "bold", fontSize:"20px"}}>Ingrese correctamente la informacion de su establecimiento. Esta información sera verificada para ser agregada.</p>
                         {/*INFORMACION DEL ESTABLECIMIENTO*/}
        <div className='regprimeraparte'>
            <h2>Establecimiento: {String(estable.NombreEstablecimiento)}</h2>
            <button onClick={editarbtn}  className={isediting ? 'editardespues' : 'editarantes'} >Editar</button>

            <div className='divperfil_edit'>
                <h2>Foto de portada:</h2>
                {isediting ? (<>
                <input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 'perfil', 0)} />
                {imgcan['perfil']?.[0] && (
                    <>
                        <div className="croper">
                        <Cropper
                            image={imgcan['perfil']?.[0]}
                            crop={crop['perfil']?.[0] || { x: 0, y: 0 }}
                            zoom={zoom['perfil']?.[0] || 1}
                            aspect={16 / 10}
                            onCropChange={(newCrop) => updateCrop('perfil', 0, newCrop)}
                            onZoomChange={(newZoom) => updateZoom('perfil', 0, newZoom)}
                            onCropComplete={(_, areaPixels) => updateCroppedAreaPixels('perfil', 0, areaPixels)}
                        />
                        </div>
                        <input type="range" min={1} max={3} step={0.1} value={zoom['perfil']?.[0] || 1} onChange={(e) => updateZoom(0, 0, parseFloat(e.target.value))}/>
                    </>
                    )}
                </>):(<>
                    <img src={`https://chamuscon.com/imgs/canchas/${alldatos[0].slug}/${alldatos[0].id_establecimiento}_cancha_1_tipo_perfil.webp`} className='pefil_edit' />
                </>)}
            </div>

            <p className='pestablecimiento'>Coloca la información del establecimiento, es decir, informacion que pueden ver los clientes.</p>
            <div className='contenedor1'> 
                <form name='formulario'>   
                <div className='rcol1'>
                    <p>Nombre del establecimiento</p>
                    <input type="text" placeholder="Nombre" maxLength={30} name='NombreEstablecimiento' value={estable.NombreEstablecimiento}
                    onInput={Registrar} style={{ borderColor: errors.NombreEstablecimiento ? 'red' : 'initial' }} disabled={isediting ? false : true}/>
                    <h3>Dirección del establecimiento</h3>
                    {/**<p>Departamento</p>
                    <input type="text" placeholder="Departamento" maxLength={50} name='Departamento' value={estable.Departamento}
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required/>
                    <p>Municipio</p>
                    <input type="text" placeholder="Municipio" maxLength={50} name='Municipio' value={estable.Municipio}
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required/>
                    <p>Zona</p>
                    <input type="text" placeholder="Zona" maxLength={50} name='Zona' value={estable.Zona}
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required/> */}
                    <p>Dirección</p>
                    <input type="text" placeholder="Direccion" maxLength={50} name='DireccionEstablecimiento' value={estable.DireccionEstablecimiento}
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required disabled={isediting ? false : true}/>
                </div>
                <div className='rcol2'>
                    <p>Teléfono para contacto</p>
                    <input type="number" placeholder="Telefono" maxLength={8} name='TelefonoEstablecimiento'  value={estable.TelefonoEstablecimiento}
                    onInput={Registrar} style={{ borderColor: errors.TelefonoEstablecimiento ? 'red' : 'initial' }} disabled={isediting ? false : true}/>
                    <p>WhatsApp</p>
                    <input type="number" placeholder="Numero" maxLength={8} name='WhatsappEstablecimiento' onInput={Registrar} value={estable.WhatsappEstablecimiento}
                    style={{ borderColor: errors.WhatsappEstablecimiento ? 'red' : 'initial' }} disabled={isediting ? false : true}/>
                    <p>Descripción del establecimiento:</p>
                    <textarea className='inpDescripcion' name='DescripcionEstablecimiento' onInput={Registrar} placeholder='Describa su establecimiento' value={estable.DescripcionEstablecimiento}
                    style={{ borderColor: errors.DescripcionEstablecimiento ? 'red' : 'initial' }} disabled={isediting ? false : true}/>
                </div>
                </form></div>
                <form>
                <div className='horarios'><h3> Horarios </h3>
                <table className='thorarios'>
                    <thead>
                        <th>Dia</th>
                        <th>Apertura</th>
                        <th>Cierre</th>
                    </thead>
                    <tbody>
                    <tr>
                            <td>Lunes<br/><label>Cerrado <input className='dialunes' type='checkbox' checked={checkboxes.dialunes} onClick={handleCheckboxChange} disabled={isediting ? false : true}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.dialunes ? true : false || isediting ? false : true} name='LunApertura' onInput={Registrar} value={estable.LunApertura}
                            style={{ borderColor: errors.LunApertura ? 'red' : 'initial' }}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.dialunes? true : false || isediting ? false : true} name='LunCierre' onInput={Registrar} value={estable.LunCierre}
                            style={{ borderColor: errors.LunCierre ? 'red' : 'initial' }}/></label></td>
                            
                        </tr>
                        <tr>
                            <td>Martes<br/><label>Cerrado <input className='diamartes' type='checkbox' checked={checkboxes.diamartes} onClick={handleCheckboxChange} disabled={isediting ? false : true}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamartes? true : false || isediting ? false : true} name='MarApertura' onInput={Registrar} value={estable.MarApertura}
                            style={{ borderColor: errors.MarApertura ? 'red' : 'initial' }}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamartes? true : false || isediting ? false : true} name='MarCierre' onInput={Registrar} value={estable.MarCierre}
                            style={{ borderColor: errors.MarCierre ? 'red' : 'initial' }}/></label></td>
                        </tr>
                        <tr>
                            <td>Miércoles<br/><label>Cerrado <input className='diamiercoles' type='checkbox' checked={checkboxes.diamiercoles} onClick={handleCheckboxChange} disabled={isediting ? false : true}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamiercoles? true : false || isediting ? false : true} name='MieApertura' onInput={Registrar} value={estable.MieApertura}
                            style={{ borderColor: errors.MieApertura ? 'red' : 'initial' }}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamiercoles? true : false || isediting ? false : true} name='MieCierre' onInput={Registrar} value={estable.MieCierre}
                            style={{ borderColor: errors.MieCierre ? 'red' : 'initial' }}/></label></td>
                        </tr>
                        <tr>
                            <td>Jueves<br/><label>Cerrado <input className='diajueves' type='checkbox' checked={checkboxes.diajueves} onClick={handleCheckboxChange} disabled={isediting ? false : true}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diajueves? true : false || isediting ? false : true} name='JueApertura' onInput={Registrar} value={estable.JueApertura}
                            style={{ borderColor: errors.JueApertura ? 'red' : 'initial' }}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diajueves? true : false || isediting ? false : true} name='JueCierre' onInput={Registrar} value={estable.JueCierre}
                            style={{ borderColor: errors.JueCierre ? 'red' : 'initial' }}/></label></td>
                        </tr>
                        <tr>
                            <td>Viernes<br/><label>Cerrado <input className='diaviernes' type='checkbox' checked={checkboxes.diaviernes} onClick={handleCheckboxChange} disabled={isediting ? false : true}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diaviernes? true : false || isediting ? false : true} name='VieApertura' onInput={Registrar} value={estable.VieApertura}
                            style={{ borderColor: errors.VieApertura ? 'red' : 'initial' }}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diaviernes? true : false || isediting ? false : true} name='VieCierre' onInput={Registrar} value={estable.VieCierre}
                            style={{ borderColor: errors.VieCierre ? 'red' : 'initial' }}/></label></td>
                        </tr>
                        <tr>
                            <td>Sábado<br/><label>Cerrado <input className='diasabado' type='checkbox' checked={checkboxes.diasabado} onClick={handleCheckboxChange} disabled={isediting ? false : true}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diasabado? true : false || isediting ? false : true} name='SabApertura' onInput={Registrar} value={estable.SabApertura}
                            style={{ borderColor: errors.SabApertura ? 'red' : 'initial' }}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diasabado? true : false || isediting ? false : true} name='SabCierre' onInput={Registrar} value={estable.SabCierre}
                            style={{ borderColor: errors.SabCierre ? 'red' : 'initial' }}/></label></td>
                        </tr>
                        <tr>
                            <td>Domingo<br/><label>Cerrado <input className='diadomingo' type='checkbox' checked={checkboxes.diadomingo} onClick={handleCheckboxChange} disabled={isediting ? false : true}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diadomingo? true : false || isediting ? false : true} name='DomApertura' onInput={Registrar} value={estable.DomApertura}
                            style={{ borderColor: errors.DomApertura ? 'red' : 'initial' }}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diadomingo? true : false || isediting ? false : true} name='DomCierre' onInput={Registrar} value={estable.DomCierre}
                            style={{ borderColor: errors.DomCierre ? 'red' : 'initial' }}/></label></td>
                        </tr>
                    </tbody>
                </table></div>
            <br/>
            <div className='parqueo'>
                <h3>Cuentas con:</h3>
                <p className='txtparqueo'>Haz clic sobre los extras que posees</p>
                <div>
                <label className='custom-checkbox'>
                    <input type='checkbox' className='tieneparqueo' checked={checkboxes.tieneparqueo} onChange={handleCheckboxChange} 
                    disabled={isediting ? false : true}/>
                    <span className='checkbox-image'>
                        <img src={Parqueo} alt='Parqueo' /> {/* Add your image here */}
                    </span>
                    Parqueo
                </label>
                <label className='custom-checkbox'>
                    <input type='checkbox' className='efectivo' checked={checkboxes.efectivo} onChange={handleCheckboxChange} 
                    disabled={isediting ? false : true}/>
                    <span className='checkbox-image'>
                        <img src={Cash} alt='Efectivo' /> {/* Add your image here */}
                    </span>
                    Pago efectivo
                </label>
                <label className='custom-checkbox'>
                    <input type='checkbox' className='tarjeta' checked={checkboxes.tarjeta} onChange={handleCheckboxChange} 
                    disabled={isediting ? false : true}/>
                    <span className='checkbox-image'>
                        <img src={Tarjeta} alt='Tarjeta' /> {/* Add your image here */}
                    </span>
                    Pago tarjeta
                </label>
                <label className='custom-checkbox'>
                    <input type='checkbox' className='transferencia' checked={checkboxes.transferencia} onChange={handleCheckboxChange} 
                    disabled={isediting ? false : true}/>
                    <span className='checkbox-image'>
                        <img src={Deposito} alt='Transferencia' /> {/* Add your image here */}
                    </span>
                    Pago transferencia
                </label>
                </div>
                    {/*Add more checkboxes as needed*/} 
            </div>
            <br/>
                        {/*REGISTRO DE CANCHAS*/}
            <div className='canchas'>
            <h3>Ingreso de canchas</h3>
            <p>Si deseas editar la cantidad de canchas o su arreglo, contactanos a: <a href='mailto:chamuscongt@gmail.com'>chamuscongt@gmail.com</a></p>
            {canchasfut5.length > 0 ? (<>
                <p><b>Canchas de fútbol 5</b></p>
                <table className='canchasedit'>
                    <tr><th><b>Nombre</b></th><th><b>Descripción</b></th><th><b>Precio</b></th><th><b>Depósito</b></th><th><b>Foto</b></th></tr>
                   {canchasfut5?.map((cancha, i, alldata)=>(<>
                        <tr>
                            <td key={i}><b>{cancha.nombre}</b></td>
                            <td className='inputf5y7'><input type='text' value={cancha.descripcion} className='Desc' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'descripcion', e.target.value)}/></td>
                            <td><input type='text' value={cancha.Precio} className='Preced' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'Precio', e.target.value)}/></td>
                            <td><input type='text' value={cancha.Deposito} className='Deped' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'Deposito', e.target.value)}/></td>
                            <td>{isediting ? (<>
                            <input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 5, i)} />
                            {imgcan[5]?.[i] && (
                                <>
                                <input type="range" min={1} max={3} step={0.1} value={zoom[5]?.[i] || 1} onChange={(e) => updateZoom(5, i, parseFloat(e.target.value))}/>
                                    <div className="croperca">
                                    <Cropper
                                        image={imgcan[5]?.[i]}
                                        crop={crop[5]?.[i] || { x: 0, y: 0 }}
                                        zoom={zoom[5]?.[i] || 1}
                                        aspect={1 / 1}
                                        onCropChange={(newCrop) => updateCrop(5, i, newCrop)}
                                        onZoomChange={(newZoom) => updateZoom(5, i, newZoom)}
                                        onCropComplete={(_, areaPixels) => updateCroppedAreaPixels(5, i, areaPixels)}
                                        objectFit='cover'
                                    />
                                    </div>
                                </>
                                )}
                            </>):(<><img src={`https://chamuscon.com/imgs/canchas/${alldatos[0].slug}/${alldatos[0].id_establecimiento}_cancha_${i + 1}_tipo_${5}.webp`} 
                            className='cancha_edit'/></>)}
                            </td>      
                        </tr>
                    </>))}
                </table><br/>
                </>):(<></>)}
            {canchasfut7.length > 0 ? (<>
                <p><b>Canchas de fútbol 7</b></p>
            <table className='canchasedit'>
                    <tr><th><b>Nombre</b></th><th><b>Descripción</b></th><th><b>Precio</b></th><th><b>Depósito</b></th><th><b>Foto</b></th></tr>
                   {canchasfut7?.map((cancha, i, alldata)=>(<>
                        <tr>
                            <td key={i}><b>{cancha.nombre}</b></td>
                            <td className='inputf5y7'><input type='text' value={cancha.descripcion} className='Desc' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'descripcion', e.target.value)}/></td>                            
                            <td><input type='text' value={cancha.Precio} className='Preced' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'Precio', e.target.value)}/></td>
                            <td><input type='text' value={cancha.Deposito} className='Deped' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'Deposito', e.target.value)}/></td>
                            <td>
                                {isediting ? (<>
                                <input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 7, i)} />
                                {imgcan[7]?.[i] && (
                                <><br/>
                                    <input type="range" min={1} max={3} step={0.1} value={zoom[7]?.[i] || 1} onChange={(e) => updateZoom(7, i, parseFloat(e.target.value))}/>
                                    <div className="croperca">
                                    <Cropper
                                        image={imgcan[7]?.[i]}
                                        crop={crop[7]?.[i] || { x: 0, y: 0 }}
                                        zoom={zoom[7]?.[i] || 1}
                                        aspect={1 / 1}
                                        onCropChange={(newCrop) => updateCrop(7, i, newCrop)}
                                        onZoomChange={(newZoom) => updateZoom(7, i, newZoom)}
                                        onCropComplete={(_, areaPixels) => updateCroppedAreaPixels(7, i, areaPixels)}
                                        objectFit='cover'
                                    />
                                    </div>
                                </>
                                )}</>):(<>
                                <img src={`https://chamuscon.com/imgs/canchas/${alldatos[0].slug}/${alldatos[0].id_establecimiento}_cancha_${i + 1}_tipo_${7}.webp`} 
                            className='cancha_edit'/>
                                </>)}
                            </td>            
                        </tr>
                    </>))}
                </table><br/>
            </>):(<></>)}
            {canchasfut11.length > 0 ? (<>
                <p><b>Canchas de fútbol 11</b></p>
            <table className='canchasedit'>
                    <tr><th><b>Nombre</b></th><th><b>Descripción</b></th><th><b>Precio</b></th><th><b>Depósito</b></th><th><b>Foto</b></th></tr>
                   {canchasfut11?.map((cancha, i, alldata)=>(<>
                        <tr>
                            <td key={i}><b>{cancha.nombre}</b></td>
                            <td className='inputf5y7'><input type='text' value={cancha.descripcion} className='Desc' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'descripcion', e.target.value)}/></td>
                            <td><input type='text' value={cancha.Precio} className='Preced' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'Precio', e.target.value)}/></td>
                            <td><input type='text' value={cancha.Deposito} className='Deped' disabled={isediting ? false : true}
                            onChange={(e) => handleDataCinco(i, 'Deposito', e.target.value)}/></td>
                            <td>{isediting ? (<>
                                <input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 11, i)} />
                                {imgcan[11]?.[i] && (
                                <><br/>
                                    <input type="range" min={1} max={3} step={0.1} value={zoom[11]?.[i] || 1} onChange={(e) => updateZoom(11, i, parseFloat(e.target.value))}/>
                                    <div className="croperca">
                                    <Cropper
                                        image={imgcan[11]?.[i]}
                                        crop={crop[11]?.[i] || { x: 0, y: 0 }}
                                        zoom={zoom[11]?.[i] || 1}
                                        aspect={1 / 1}
                                        onCropChange={(newCrop) => updateCrop(11, i, newCrop)}
                                        onZoomChange={(newZoom) => updateZoom(11, i, newZoom)}
                                        onCropComplete={(_, areaPixels) => updateCroppedAreaPixels(11, i, areaPixels)}
                                        objectFit='cover'
                                    />
                                    </div>
                                </>
                                )}
                            </>):(<>
                                <img src={`https://chamuscon.com/imgs/canchas/${alldatos[0].slug}/${alldatos[0].id_establecimiento}_cancha_${i + 1}_tipo_${11}.webp`} 
                                className='cancha_edit'/></>)}    
                            </td>                              
                        </tr>
                    </>))}
                </table>
            </>):(<></>)}
            </div>
            </form>
        </div>
                                {/*INFORMACION DEL DUENO*/}
        <div>
        <form>
            <h2 >Informacion de contacto</h2>
            <div className='contenedor2'>
                <p className='pcontacto'>Coloca la información de la persona propietaria del establecimiento.</p>
                    <p>Nombre y apellido</p>
                    <input type="text" placeholder="Nombre y apellido" maxLength={30} name='NombreDueno' onInput={Registrar} disabled={isediting ? false : true}
                    style={{ borderColor: errors.NombreDueno ? 'red' : 'initial' }} value={estable.NombreDueno}/>
                    <br/>
                    <p>DPI</p>
                    <input type="number" placeholder="DPI" minLength={12} maxLength={13} name='DPIDueno' onInput={Registrar} disabled={isediting ? false : true}
                    style={{ borderColor: errors.DPIDueno ? 'red' : 'initial' }} value={estable.DPIDueno}/>
            </div>
        </form></div>
        <button className='registrar' onClick={handleSubmit2} disabled={isediting ? false : true} >
            Guardar
        </button>
        {/**{datosing === '' ? (
            <div className='cuadro'>
            <div className='msgingreso'>
                <h1>Datos por ingresar</h1>
            </div></div>
        ): datosing === 'ingresados' ? (
            <div className=''>
            <div className='msgingreso'>
                <h1>Datos ingresados correctamente</h1>
            </div></div>
        ): datosing === 'error' (
            <div className=''>
            <div className='msgingreso'>
                <h1>Datos ingresados erroneamente, verifique que todos los datos son validos.</h1>
            </div></div>
        )}*/}
        </>)}
    </div><Toaster /> </>
    );
}

export default EditarEst;